import Footer from '@/components/FooterSC/Footer';
import { Header } from '@/components/Header/Header';

type RootLayoutProps = {
  children: React.ReactNode;
  locale: string;
};

export function PageWithAsideLayout({ children, locale }: RootLayoutProps) {
  return (
    <>
      <Header />
      <div className="flex flex-col lg:flex-row lg:min-h-[calc(100vh-70px)]">
        {children}
      </div>
      <Footer locale={locale} />
    </>
  );
}
